// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incoming-call-bar {
  background-color: #e3f2fd;
  border-bottom: 2px solid #1976d2;
}

.incoming-call-bar-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px;
  gap: 16px;
}

.incoming-call-bar-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.incoming-call-bar-pulse {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #1976d2;
  animation: incoming-call-pulse 1.2s ease-in-out infinite;
}

@keyframes incoming-call-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.35;
    transform: scale(1.4);
  }
}

/* Respect users who have asked the OS to reduce motion — the color and buttons
   already carry the meaning without the animation. */
@media (prefers-reduced-motion: reduce) {
  .incoming-call-bar-pulse {
    animation: none;
  }
}

.incoming-call-bar-label {
  font-weight: 600;
  color: #0d47a1;
  font-size: 15px;
}

.incoming-call-bar-number {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 14px;
  color: #1565c0;
  font-weight: 500;
  background: rgba(25, 118, 210, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
}

.incoming-call-bar-controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.icb-btn {
  padding: 6px 18px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s;
}

.icb-btn-answer {
  background-color: #4caf50;
  color: #fff;
}

.icb-btn-answer:hover {
  background-color: #388e3c;
}

.icb-btn-reject {
  background-color: #f44336;
  color: #fff;
}

.icb-btn-reject:hover {
  background-color: #d32f2f;
}

@media (max-width: 768px) {
  .incoming-call-bar-main {
    flex-direction: column;
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CallControls/IncomingCallBar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,qBAAqB;EACvB;AACF;;AAEA;qDACqD;AACrD;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":[".incoming-call-bar {\n  background-color: #e3f2fd;\n  border-bottom: 2px solid #1976d2;\n}\n\n.incoming-call-bar-main {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 24px;\n  gap: 16px;\n}\n\n.incoming-call-bar-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.incoming-call-bar-pulse {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #1976d2;\n  animation: incoming-call-pulse 1.2s ease-in-out infinite;\n}\n\n@keyframes incoming-call-pulse {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.35;\n    transform: scale(1.4);\n  }\n}\n\n/* Respect users who have asked the OS to reduce motion — the color and buttons\n   already carry the meaning without the animation. */\n@media (prefers-reduced-motion: reduce) {\n  .incoming-call-bar-pulse {\n    animation: none;\n  }\n}\n\n.incoming-call-bar-label {\n  font-weight: 600;\n  color: #0d47a1;\n  font-size: 15px;\n}\n\n.incoming-call-bar-number {\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 14px;\n  color: #1565c0;\n  font-weight: 500;\n  background: rgba(25, 118, 210, 0.1);\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.incoming-call-bar-controls {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.icb-btn {\n  padding: 6px 18px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.icb-btn-answer {\n  background-color: #4caf50;\n  color: #fff;\n}\n\n.icb-btn-answer:hover {\n  background-color: #388e3c;\n}\n\n.icb-btn-reject {\n  background-color: #f44336;\n  color: #fff;\n}\n\n.icb-btn-reject:hover {\n  background-color: #d32f2f;\n}\n\n@media (max-width: 768px) {\n  .incoming-call-bar-main {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
